enum CertificateDialogFields {
	CERTIFICATE = "certificate",
	ALIAS = "alias",
	PASSWORD = "password"
}

export default CertificateDialogFields;